import axios, {type AxiosError} from 'axios';
import {ElNotification} from "element-plus";

export const axiosVars = {
    baseURL: import.meta.env.VITE_API_BASE_URL,
    apiKey: import.meta.env.VITE_API_KEY
}
export interface ApiResponse<T> {
    status: string;
    data: T;
}

const api = axios.create({
    baseURL: axiosVars.baseURL, // Get the base URL from env
    timeout: parseInt(import.meta.env.VITE_API_TIMEOUT) || 5000,
    headers: {
        'Accept': 'application/json',
        'API-KEY': axiosVars.apiKey,
        'Accept-Language': sessionStorage.getItem('lang') || 'de',
    }
});



api.interceptors.request.use(
    (config) => {
        // Example: Add auth token
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

export const doError= (error: AxiosError | any)=> {
    const e=error.response?.data?.message || 'An error occurred';
    ElNotification({
        type: 'error',
        title: e,
    })
    throw new Error(e);
}
export default api;
